module.exports = __webpack_public_path__ + "46be0ed1e594af45a15a9c3d5fd59c1c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Dollarbag.png
// module id = 1430
// module chunks = 0